import React, { createContext, useContext, useMemo } from 'react';
import { useUnifiedPageLayoutQuery } from '../hooks/useUnifiedPageLayoutQuery';
export const PageLayoutContext = createContext(undefined);
export const PageLayoutProvider = ({ children }) => {
    const { pageLayoutQuery, getSectionBySectionKey } = useUnifiedPageLayoutQuery();
    const value = useMemo(() => ({
        pageLayoutQuery,
        getSectionBySectionKey,
    }), [pageLayoutQuery, getSectionBySectionKey]);
    return React.createElement(PageLayoutContext.Provider, { value: value }, children);
};
export const usePageLayoutContext = () => {
    const pageLayoutContext = useContext(PageLayoutContext);
    if (pageLayoutContext === undefined) {
        throw new Error('pageLayoutContext must be used within a PageLayoutProvider');
    }
    return pageLayoutContext;
};
